import * as React from "react";

import "./customization-lost-warning-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const CustomizationLostWarningModal = ({startNewOrder, showLoadingSpinner, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Customization Lost Warning Modal",
        rootNext,
        next,
        xToClose: true,
        width: 550,
    })],

    ({modal}) => (
        <div className="customization-lost-warning-modal-73s">
            <div className="icon">
                <div className="circle">
                    <i className="fa fa-exclamation-triangle"/>
                </div>
            </div>

            <div className="message">
                <div className="line">
                    Your customization will be lost.
                </div>
                <div className="line">
                    Are you sure you want to proceed?
                </div>
            </div>

            <div className="buttons">
                <button
                    onClick={async () => {
                        modal.close();
                        showLoadingSpinner.onChange(true);
                        await startNewOrder();
                    }}
                    className="proceed"
                >
                    Proceed
                </button>
                <button
                    onClick={() => modal.close()}
                    className="cancel"
                >
                    Cancel
                </button>
            </div>
        </div>
    ),
);